import mushroom from "mushroomjs";
import ApiService, { callCustomMethodAsync } from "../service/ApiService";

let moduleApi = {};
let moduleName = "employee_draff";

moduleApi.create = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter, loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: loading == undefined ? false : loading,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id },
    message: {
      success: "Xóa nhân viên thành công!",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id, loading) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id },
    dontLoading: loading == undefined ? false : loading,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ApproveEmployeeAsync = data => {
  let api = {
    module: moduleName,
    type: "ApproveEmployeeAsync",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.UnApproveEmployeeAsync = data => {
  let api = {
    module: moduleName,
    type: "UnApproveEmployeeAsync",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};


export default moduleApi;
